// v10/src/components/aircraft/AogBadge.js
//
// Badge reutilizable "AOG" para cards/headers de aeronaves. Se alinea con
// el selector del piloto (que usa checkAircraftAog → TBO viejo + service
// nuevo + squawks AOG manuales) consumiendo `is_aog_computed` del listado
// de aeronaves enriquecido. Cae al flag DB `is_aog` (seteado por el cron
// syncAogStatus, solo TBO viejo) si el computed no viene en la response.
//
// Uso:
//   <AogBadge aircraft={ac} />                 // tamaño default 'sm'
//   <AogBadge aircraft={ac} size="md" />
//
// Si la aeronave no es AOG por ningún criterio, no renderiza nada.

import React from 'react';
import { AlertOctagon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SIZES = {
  sm: { padding: '3px 8px',  fontSize: 10, iconSize: 11, gap: 4 },
  md: { padding: '5px 10px', fontSize: 12, iconSize: 13, gap: 5 },
  lg: { padding: '7px 12px', fontSize: 13, iconSize: 15, gap: 6 },
};

const AogBadge = ({ aircraft, size = 'sm', style = {} }) => {
  const { t } = useTranslation('admin');

  const isAog = aircraft?.is_aog_computed != null
    ? aircraft.is_aog_computed
    : aircraft?.is_aog;
  if (!isAog) return null;

  const s = SIZES[size] || SIZES.sm;
  const title = aircraft.aog_reason_computed
              || aircraft.aog_reason
              || t('aog_badge_default_reason');

  return (
    <span
      title={title}
      aria-label={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        padding: s.padding,
        borderRadius: 999,
        background: 'rgba(239,68,68,0.1)',
        border: '1px solid rgba(239,68,68,0.3)',
        color: '#dc2626',
        fontSize: s.fontSize,
        fontWeight: 800,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <AlertOctagon style={{ width: s.iconSize, height: s.iconSize }} />
      {t('aog_badge_label')}
    </span>
  );
};

export default AogBadge;
